<template>
	<div class="login">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-6 col-lg-5">
					<div class="login-wrap p-4 p-md-5">
						<h3 class="text-center mb-4">Please reset your password</h3>
						<form @submit.prevent="submit" class="forgot-form">
							<div class="form-group">
								<input
									type="password"
									class="form-control rounded-left"
									v-model="password"
									placeholder="New Password"
									required
								/>
							</div>
							<div class="form-group">
								<input
									type="password"
									class="form-control rounded-left"
									v-model="confirm"
									placeholder="confirm"
									required
								/>
							</div>
							<div v-if="message !==''" class="form-group">
								<p v-if="showError" style="color: #8D448B !important;">
									{{ message }}
								</p>
							</div>
							<div class="form-group">
								<button
									type="submit"
									class="btn btn-primary rounded submit"
								>
									Save Password
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions } from "vuex";

export default {
	name: "ResetPassword",
	components: {},
	data() {
		return {
			password: "",
			confirm: "",
			showError: false,
			message: '',
			token: ''
		};
	},
	created() {
		this.token = this.$route.query.token;
	},
	methods: {
		...mapActions({
			resetpassword: "auth/ResetPassword",
		}),
		async submit() {
			try {
				if (this.password !== this.confirm) {
					this.message = 'Does not match password';
					this.showError = true;
				} else {
					const data = await this.resetpassword({
						token: this.token,
						password: this.password
					});
					if (!!data.message) {
						this.message = data.message;
						this.showError = true;
						this.$toasted.show("Password is successfully ", {
							type: "success",
							closeOnSwipe: true,
							fitToScreen: true,
							duration: 2500,
							theme: "bubble",
						});

						setTimeout(() => {
							this.$router.push("/login");
						}, 2000);
					} else {
						this.showError = false;
					}
				}
			} catch (error) {
				console.log(error)
				this.showError = true;
			}
		}
	},
};
</script>
<style lang="scss" scoped>
$font-primary: "Lato", Arial, sans-serif;
$primary: #8d448b;
$black: #000;
$white: #fff;
.login {
	height: 100vh;
	font-family: $font-primary;
	font-size: 16px;
	line-height: 1.8;
	font-weight: normal;
	color: lighten($black, 50%);
	background-image: url("../../assets/img/background1.png");
	background-repeat: no-repeat;
	background-size: cover;
	padding: 15px 20px 20px 20px;
}
a {
	transition: 0.3s all ease;
	color: $primary;
	&:hover,
	&:focus {
		text-decoration: none !important;
		outline: none !important;
		box-shadow: none;
		color: $primary;
	}
}
h1,
h2,
h3,
h4,
h5,
.h1,
.h2,
.h3,
.h4,
.h5 {
	line-height: 1.5;
	font-weight: 400;
	font-family: $font-primary;
	color: $black;
}

.bg-primary {
	background: $primary !important;
}

.ftco-section {
	padding: 7em 0;
}

.ftco-no-pt {
	padding-top: 0;
}
.ftco-no-pb {
	padding-bottom: 0;
}
//HEADING SECTION
.heading-section {
	font-size: 28px;
	color: $black;
}

//COVER BG
.img {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
}

.login-wrap {
	position: relative;
	top: 65%;
	background: #ecf0f3;
	border-radius: 10px;
	-webkit-box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);
	-moz-box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);
	box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);
	h3 {
		font-weight: 700;
		font-size: 20px;
		color: $primary;
	}
	.icon {
		width: 80px;
		height: 80px;
		background: $primary;
		border-radius: 50%;
		font-size: 30px;
		margin: 0 auto;
		margin-bottom: 10px;
		span {
			color: $white;
		}
	}
}

//FORM CONTROL
.form-control {
	height: 48px;
	background: rgba(0, 0, 0, 0.05);
	color: $black;
	font-size: 16px;
	box-shadow: none;
	border: 1px solid transparent;
	padding-left: 20px;
	padding-right: 20px;
	&::-webkit-input-placeholder {
		/* Chrome/Opera/Safari */
		color: rgba(0, 0, 0, 0.2) !important;
	}
	&::-moz-placeholder {
		/* Firefox 19+ */
		color: rgba(0, 0, 0, 0.2) !important;
	}
	&:-ms-input-placeholder {
		/* IE 10+ */
		color: rgba(0, 0, 0, 0.2) !important;
	}
	&:-moz-placeholder {
		/* Firefox 18- */
		color: rgba(0, 0, 0, 0.2) !important;
	}
	&:focus,
	&:active {
		outline: none !important;
		box-shadow: none;
		background: rgba(0, 0, 0, 0.07);
		border-color: transparent;
	}
}
//CHECKBOX STYLE
.checkbox-wrap {
	display: block;
	position: relative;
	top: 35%;
	padding-left: 30px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 16px;
	font-weight: 500;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-wrap input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 0;
	left: 0;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: "\f0c8";
	font-family: "FontAwesome";
	position: absolute;
	color: rgba(0, 0, 0, 0.1);
	font-size: 20px;
	margin-top: -4px;
}

/* Show the checkmark when checked */
.checkbox-wrap {
	input:checked ~ .checkmark:after {
		display: block;
		content: "\f14a";
		font-family: "FontAwesome";
		color: rgba(0, 0, 0, 0.2);
	}
}

/* Style the checkmark/indicator */
.checkbox-wrap .checkmark:after {
}

.checkbox-primary {
	color: $primary;
	input:checked ~ .checkmark:after {
		color: $primary;
	}
}

//BUTTON
.btn {
	cursor: pointer;
	border-radius: 40px;
	box-shadow: none !important;
	font-size: 15px;
	&:hover,
	&:active,
	&:focus {
		outline: none;
	}
	&.btn-primary {
		background: $primary !important;
		border: 1px solid $primary !important;
		color: $white !important;
		&:hover {
			border: 1px solid $primary;
			background: transparent;
			color: $primary;
		}
		&.btn-outline-primary {
			border: 1px solid $primary;
			background: transparent;
			color: $primary;
			&:hover {
				border: 1px solid transparent;
				background: $primary;
				color: $white;
			}
		}
	}
}

.form-group {
	position: relative;
	.submit {
		position: absolute;
		top: 20px;
		left: 0;
		right: 0;
		margin: 0 auto;
	}
}
</style>
